import { Decoder, object, string, array, number, boolean, optional, dict } from '@mojotech/json-type-validation';
import { IRSBank } from '../../store/pik_data/banks';
import { ILogger } from '@cian/logger';

/** Валидирует json со списком банков и информацией о них  */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRSBanksValid = (value: any, logger: ILogger): boolean => {
  const banksDecoder: Decoder<IRSBank[]> = array(
    object({
      id: number(),
      title: string(),
      gksList: optional(array(string())),
      color: optional(string()),
      fullTitle: optional(string()),
      textColor: optional(string()),
      iconStyle: optional(object()),
      isDisabled: optional(boolean()),
      mortgageByRegion: dict(
        object({
          rate: optional(string()),
          initialInstallment: optional(number()),
          maxLoanTerm: optional(number()),
          minLoanTerm: optional(number()),
          militaryMortgage: optional(boolean()),
        }),
      ),
    }),
  );
  const result = banksDecoder.run(value);
  const isValid = result.ok;

  if (!isValid) {
    logger.error('Невалидное значение runtime переменной PikLanding.Banks');
  }

  return isValid;
};
